export const extractVideoId = (link) => {
    const regex = /(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|.*[?&]v=))([a-zA-Z0-9_-]{11})/;
    const match = link?.match(regex);
    return match ? match[1] : null;
};
